import { getAxiosInstance } from "../../../axios-instance";
import type { OnboardingStepKey } from "../onboardingSteps";

export type SchedulingMethod = "paper" | "whatsapp" | "spreadsheet" | "software" | "other";
export type WeeklyPatientVolume = "lt20" | "20to50" | "50to100" | "gt100";
export type BiggestTimeSink = "scheduling" | "reminders" | "records" | "billing";

/** Matches OnboardingStateResponse on the API. */
export interface OnboardingState {
  lastCompletedStep: OnboardingStepKey | null;
  nextStep: OnboardingStepKey;
  schedulingMethod: SchedulingMethod | null;
  weeklyPatientVolume: WeeklyPatientVolume | null;
  biggestTimeSink: BiggestTimeSink | null;
  firstPatientId: number | null;
  firstAppointmentId: number | null;
  committedAt: string | null;
  completedAt: string | null;
  /** False for accounts that predate onboarding — the guard must not redirect those. */
  hasStarted: boolean;
  isComplete: boolean;
}

export interface UpdateOnboardingSurveyRequest {
  schedulingMethod?: SchedulingMethod;
  weeklyPatientVolume?: WeeklyPatientVolume;
  biggestTimeSink?: BiggestTimeSink;
}

export async function fetchMyOnboarding() {
  const res = await getAxiosInstance().get<OnboardingState>("/onboarding");
  return res.data;
}

/** Idempotent: marks the account as having entered the wizard. */
export async function startOnboarding() {
  const res = await getAxiosInstance().post<OnboardingState>("/onboarding/start");
  return res.data;
}

export async function updateOnboardingSurvey(data: UpdateOnboardingSurveyRequest) {
  const res = await getAxiosInstance().put<OnboardingState>("/onboarding/survey", data);
  return res.data;
}

export async function completeOnboardingStep(step: OnboardingStepKey) {
  const res = await getAxiosInstance().put<OnboardingState>("/onboarding/progress", { step });
  return res.data;
}

export async function updateOnboardingMilestone(data: { patientId?: number; appointmentId?: number }) {
  const res = await getAxiosInstance().put<OnboardingState>("/onboarding/milestone", data);
  return res.data;
}

export async function completeOnboarding() {
  const res = await getAxiosInstance().post<OnboardingState>("/onboarding/complete");
  return res.data;
}
